import React from "react"
import { BLOCKS, INLINES } from "@contentful/rich-text-types"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import t, { mixin } from "theme"
import styled from "@emotion/styled"
import { css } from "@emotion/core"
import SlidesEmbed from "../RichTextEmbeds/SlidesEmbed"
import YoutubeEmbed from "../RichTextEmbeds/YoutubeEmbed"
import TwitterEmbeds from "../RichTextEmbeds/TwitterEmbed"
import InlineTweet from "../RichTextEmbeds/InlineTweet"
import SmartShare from "components/UI/SmartShare"
import Card from "components/UI/Card"

const RichText = ({ body, linkUrl }) => {
    const options = {
        renderNode: {
            [BLOCKS.EMBEDDED_ASSET]: node => (
                <SmartShare linkUrl={linkUrl}>
                    <img
                        src={node.data.target.fields.file["en-US"].url}
                        alt={node.data.target.fields.title["en-US"]}
                        loading="lazy"
                        css={css`
                            width: 100%;
                            ${mixin.tabletandphonestyle} {
                                position: relative;
                                ${mixin.fullwidth}
                                height: auto;
                            }
                        `}
                    />
                </SmartShare>
            ),
            [BLOCKS.EMBEDDED_ENTRY]: node => {
                const contentType = node.data.target.sys.contentType.sys.id

                switch (contentType) {
                    case "twitterEmbed":
                        const tweetId = node.data.target.fields.tweetId["en-US"]
                        return <TwitterEmbeds tweetId={tweetId} />
                    case "youTubeEmbed":
                        const url = node.data.target.fields.url["en-US"]
                        return <YoutubeEmbed url={url} />
                    case "slide":
                        return <SlidesEmbed node={node} />
                    case "card":
                        return <Card shadow content={node.data.target.fields} />
                    default:
                        return null
                }
            },
            [INLINES.EMBEDDED_ENTRY]: node => {
                const contentType = node.data.target.sys.contentType.sys.id
                switch (contentType) {
                    case "tweetableText":
                        return (
                            <InlineTweet
                                shortText={node.data.target.fields.shortText["en-US"]}
                                tweetMessage={node.data.target.fields.tweetMessage["en-US"]}
                                pageUrl={"https://disruptionresearch.firebaseapp.com" + linkUrl}
                            />
                        )
                    default:
                        return null
                }
            },
        },
    }

    return <RichTextBody>{documentToReactComponents(body, options)}</RichTextBody>
}

export default RichText

//Styled Components

const RichTextBody = styled("div")`
    > *:not(:last-child) {
        margin-bottom: ${t.space[4]};
    }

    blockquote {
        background-color: ${t.color.bg};
        padding: ${t.space[4]};
        margin-left: 0;
        margin-right: 0;
        margin-bottom: ${t.space[4]};
        border-left: 3px solid ${t.color.primary};
        font-style: italic;
    }

    a:link,
    a:visited {
        color: ${t.color.primary};
        border-bottom: 1px dotted ${t.color.border};
    }

    ul {
        list-style-image: url("/squarebullet.png");
        margin-left: 2rem;
        p {
            padding-left: 0rem;
            padding-bottom: ${t.space[2]};
        }
    }

    ol {
        margin-left: 2rem;

        p {
            padding-bottom: ${t.space[2]};
        }
    }
`

export { RichTextBody }
